import { Menus } from '../interface/header';

export const HeaderMenuNames: Menus[] = [
  {
    name: 'App',
    menu: [
      {
        name: 'Facility',
        id: 1,
        fac_Id: null,
        subMenus: [
          {
            name: 'Cape Town',
            id: 1,
            fac_Id: 'CT'
          },
          {
            name: 'El Segundo',
            id: 2,
            fac_Id: 'ES'
          },
          {
            name: 'Hawaii',
            id: 3,
            fac_Id: 'HA'
          },
          {
            name: 'Pascagoula',
            id: 4,
            fac_Id: 'PA'
          },
          {
            name: 'Pasadena',
            id: 7,
            fac_Id: 'PS'
          },
          {
            name: 'Richmond',
            id: 5,
            fac_Id: 'RI'
          },
          {
            name: 'Salt Lake',
            id: 6,
            fac_Id: 'SL'
          },
        ],
      },
      {
        name: 'EAM Mode',
        id: 1,
        fac_Id: null,
        subMenus: [
          {
            name: 'MX - Maximo',
            id: 1,
            fac_Id: null,
          },
        ],
      },
    ],
  },
];


export const Facility = [
  {
    name: 'Cape Town',
    fac_Id: 'CT'
  },
  {
    name: 'El Segundo',
    fac_Id: 'ES'
  },
  {
    name: 'Hawaii',
    fac_Id: 'HA'
  },
  {
    name: 'Pascagoula',
    fac_Id: 'PA'
  },
  {
    name: 'Pasadena',
    fac_Id: 'PS'
  },
  {
    name: 'Richmond',
    fac_Id: 'RI'
  },
  {
    name: 'Salt Lake',
    fac_Id: 'SL'
  },
]
